import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormSection from 'components/sales/formSection/formSection';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import { handleValidateObj } from 'constants/objValues/objvalues';

const OtherInfo = ({
  dropDownData,
  getDropDownData,
  handleValue,
  leadId,
  documentUploadUrl,
  documentUrlData,
}) => {
  const inputData = {
    marketing_commitment: '',
    marketing_commitment_description: '',
    payment_terms: '',
    partner_logo: '',
    agreement_doc: '',
    new_feature_required: '',
    new_feature_description: '',
    vehicle_type: '',
  };
  const yesNo = [
    { id: 1, name: 'Yes' },
    { id: 0, name: 'No' },
  ];

  const [formData, setData] = useState(inputData);
  const handleData = () => {
    if (formData.marketing_commitment !== '') {
      handleValue({
        ...formData,
        lead_id: leadId,
      });
    } else {
      handleValue(null);
    }
  };
  useEffect(() => {
    handleData();
  }, [formData]);

  useEffect(() => {
    (async () => {
      await getDropDownData(1);
    })();
  }, []);
  return (
    <FormSection title={localization.otherDetail}>
      <DropDownInput
        label={localization.marketing}
        inputValue={formData.appAvail}
        data={dropDownData.marketingCommitment}
        type="text"
        getIdValue={(value) =>
          setData({ ...formData, marketing_commitment: value.id })
        }
        className={formData.marketing_commitment.length ? '' : 'empty'}
        errorMsg={localization.requiredmarketing}
        required
        isStarRequired={true}
      />
      {formData.marketing_commitment ? (
        <ConstantInput
          label={localization.description}
          inputValue={formData.marketing_commitment_description}
          type="text"
          handleChange={(value) =>
            setData({ ...formData, marketing_commitment_description: value })
          }
          regex={Regex.alphaNum.test(formData.marketing_commitment_description)}
          errorMsg={localization.requireddescription}
          required
          isStarRequired={true}
        />
      ) : null}
      <DropDownInput
        label={localization.vehicleType}
        data={dropDownData.vehicleType}
        errorMsg={localization.requiredvehicleType}
        inputValue={formData.appAvail}
        type="text"
        getIdValue={(value) => setData({ ...formData, vehicle_type: value.id })}
        errorMsg={localization.isRequired}
        required
        isStarRequired={true}
      />
      <ConstantInput
        label={localization.paymentTerm}
        inputValue={formData.payment_terms}
        type="text"
        handleChange={(value) => setData({ ...formData, payment_terms: value })}
        regex={Regex.alphaNum.test(formData.payment_terms)}
        errorMsg={localization.requiredpaymentTerms}
        required
        isStarRequired={true}
      />
      <DropDownInput
        label={localization.newFeature}
        inputValue={formData.newFeature}
        data={yesNo}
        type="text"
        getIdValue={(value) =>
          setData({ ...formData, new_feature_required: value.value })
        }
        errorMsg={localization.requirednewFeature}
        required
        isStarRequired={true}
      />
      <ConstantInput
        label={localization.featureDesc}
        inputValue={formData.new_feature_description}
        type="text"
        handleChange={(value) =>
          setData({ ...formData, new_feature_description: value })
        }
        regex={Regex.alphaNum.test(formData.new_feature_description)}
        errorMsg={localization.requiredfeatureDesc}
        required
        isStarRequired={true}
      />
      <div className="form-group upload-full-width">
        <FileUpload
          id="partnerLogo"
          accept=".png,.jpg,.jpeg,.svg"
          documentUploadUrl={documentUploadUrl}
          documentUrlData={documentUrlData}
          onChange={(val) =>
            setData({
              ...formData,
              partner_logo: val,
            })
          }
        >
          <span className="btn btn-transparent">
            {localization.partnerLogoUpload}
          </span>
        </FileUpload>
      </div>

      <div className="form-group upload-full-width">
        <FileUpload
          id="agreementTnCUpload"
          accept=".pdf,.png,.jpg,.jpeg,.doc"
          documentUploadUrl={documentUploadUrl}
          documentUrlData={documentUrlData}
          onChange={(val) =>
            setData({
              ...formData,
              agreement_doc: val,
            })
          }
        >
          <span className="btn btn-transparent">
            {localization.agreementTnCUpload}
          </span>
        </FileUpload>
      </div>
    </FormSection>
  );
};

OtherInfo.propTypes = {};

export default OtherInfo;
